import { Box, Button, Chip } from "@mui/material";

import { formatDateShort } from "@/common/utils";

import styles from "./NotesPanelReportTabs.module.scss";

export interface ReportTabItem {
  submission_id: string;
  time_submitted?: string | null;
  time_created?: string | null;
}

interface NotesPanelReportTabsProps {
  reports: (ReportTabItem | undefined)[];
  currentIndex: number;
  onNavigate: (index: number) => void;
}

export function NotesPanelReportTabs({
  reports,
  currentIndex,
  onNavigate,
}: NotesPanelReportTabsProps) {
  if (reports.length <= 1) return null;

  const currentReport = reports[currentIndex];
  const isSupplemental = currentIndex !== 0;

  return (
    <>
      <Box className={styles.navigationContainer}>
        <Box className={styles.reportButtonGroup}>
          {reports.map((report, index) => (
            <Button
              key={report?.submission_id ?? index}
              variant={index === currentIndex ? "contained" : "outlined"}
              color="info"
              size="small"
              onClick={() => onNavigate(index)}
              className={styles.reportButton}
            >
              {index === 0 ? "Main" : `S${index}`}
            </Button>
          ))}
        </Box>
      </Box>
      {isSupplemental && currentReport && (
        <Chip
          label={`Submitted: ${formatDateShort(
            currentReport?.time_submitted ?? currentReport?.time_created,
          )}`}
          size="small"
          color="secondary"
          className={styles.supplementalChip}
        />
      )}
    </>
  );
}
